module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"sort_products":"Sort Products","drag_and_drop":"Drag and drop the","icon_to_rearrange":"icon to rearrange the products"},"id":{"sort_products":"Urutkan Produk","drag_and_drop":"Tarik dan letakkan","icon_to_rearrange":"ikon untuk mengurutkan kategori"}}')
  delete Component.options._Ctor
}
